import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  phoneNumberVerification: {
    defaultMessage: 'Phone Number Verification',
  },
  changePhoneNumber: {
    defaultMessage: 'Change Phone Number',
  },
  addPhoneNumber: {
    defaultMessage: 'Add a Phone Number',
  },
  noticeFirstParagraph: {
    defaultMessage:
      'Sorare processes phone numbers for security and anti-fraud purposes (notably to monitor the respect of our terms for referral activities, non-casual line-up creations and credit cards payment).',
  },
  noticeSecondParagraph: {
    defaultMessage:
      'Along with other information, your phone number will also allow our Support Team helping you in recovering your account in the case you would have lost your authentication device and recovery code.',
  },
});
